import { render, staticRenderFns } from "./SpectrumTaskOperButton.vue?vue&type=template&id=4757761f&"
import script from "./SpectrumTaskOperButton.vue?vue&type=script&lang=js&"
export * from "./SpectrumTaskOperButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports